import {
	AfterViewInit,
	Component,
	ElementRef,
	EventEmitter,
	Input,
	OnDestroy,
	Output,
	ViewChild,
} from '@angular/core';
import { createElement, FunctionComponent } from 'react';
import { createRoot, Root } from 'react-dom/client';
import { TaxbitQuestionnaire } from '@taxbit/react-sdk';
import { environment } from '../../../../../../environments/environment';
import { TaxbitConfig } from './types/taxbit-config';
import {
	ClientTaxDocumentation,
	QuestionnaireProps,
} from './types/questionnaire-props';

@Component({
	selector: 'bcb-taxbit-form',
	template: '<div #container></div>',
})
export class TaxbitFormComponent implements AfterViewInit, OnDestroy {
	@ViewChild('container', { static: true })
	container!: ElementRef<HTMLDivElement>;

	@Input() bearerToken!: string;
	@Output() formSuccess = new EventEmitter<ClientTaxDocumentation>();
	@Output() formError = new EventEmitter<unknown>();

	private root: Root | null = null;

	ngAfterViewInit(): void {
		const cfg: TaxbitConfig = environment.taxbit!;

		const props: QuestionnaireProps = {
			bearerToken: this.bearerToken,
			questionnaire: cfg.questionnaire,
			region: cfg.region,
			language: cfg.language,
			adaptiveMode:
				cfg.adaptiveMode !== 'full' ? cfg.adaptiveMode : undefined,
			onSuccess: (data: ClientTaxDocumentation) =>
				this.formSuccess.emit(data),
			onError: (err: unknown) => this.formError.emit(err),
		};

		this.root = createRoot(this.container.nativeElement);
		this.root.render(
			createElement(
				TaxbitQuestionnaire as FunctionComponent<QuestionnaireProps>,
				props
			)
		);
	}

	ngOnDestroy(): void {
		this.root?.unmount();
		this.root = null;
	}
}
